(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const select = section.querySelector('[data-variant-select]');
      const update = () => {
        const variant = select?.selectedOptions[0];
        if (!variant) return;
        const price = section.querySelector('[data-product-price]');
        const button = section.querySelector('[data-add-button]');
        const image = section.querySelector('[data-main-image] img');
        const quantity = section.querySelector('[name="quantity"]');
        if (price) price.textContent = variant.dataset.price;
        if (button) {
          button.disabled = variant.dataset.available !== 'true';
          button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
        }
        if (image && variant.dataset.image) { image.src = variant.dataset.image; image.removeAttribute('srcset'); }
        if (quantity) {
          quantity.min = variant.dataset.min || '1'; quantity.step = variant.dataset.step || '1';
          if (variant.dataset.max) quantity.max = variant.dataset.max; else quantity.removeAttribute('max');
          if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.value);
        window.history.replaceState({}, '', url);
      };
      select?.addEventListener('change', update);
      section.querySelectorAll('[data-image-url]').forEach(button => button.addEventListener('click', () => {
        const image = section.querySelector('[data-main-image] img');
        if (image) { image.src = button.dataset.imageUrl; image.alt = button.dataset.imageAlt || ''; image.removeAttribute('srcset'); }
      }));
    });
    root.querySelectorAll('details.mobile-menu, details.nav-dropdown').forEach(details => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { details.open = false; details.querySelector('summary')?.focus(); }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
